/* Auto-generated from officeart-schemas.proto */
import { Tiling } from './tiling-schemas';
export namespace Oart {
    export interface IDrawingElement {
        id?: string;
        mk?: IDrawingElementMoniker;
        textTile?: Tiling.ITextTile;
    }
    export enum DrawingElementType {
        shape = 0,
        groupShape = 1,
        graphicFrame = 2,
        connector = 3,
        picture = 4,
        ink = 5
    }
    export interface IDrawingElementMoniker {
        id?: number;
        cId?: string;
        type?: DrawingElementType;
    }
}
